import * as Yup from 'yup';
import { error } from '../../utils/i18n';

export const username = (attribute: string) => {
  return Yup.string()
    .trim()
    .matches(/^[0-9a-z\-_.]*$/, error('username_rule'))
    .matches(/^((?!^\d{9}$).)*$/, error('username_9digits'))
    .matches(/^((?!^\d{10}$).)*$/, error('username_10digits'))
    .max(40, error('max', attribute, { max: 40 }));
};
